import { ErrorSource } from '../../../core/constant/model/api/api';
import { createApiError } from '../../../core/constant/utils/error.helper';
import { getDataFromResponse } from '../../../core/constant/utils/react-query-utils/getDataFromResponse';
import { createApiMutation } from '../../../core/hooks/useMutationFactory';
import { postEndService, postPauseService, postScheduleChangeRequest, postUpdatePersonalInfo } from '../api/accountSettings.api';
import { CoachingScheduleRequest, CoachingScheduleResponse, EditPersonalInfoRequest, EditPersonalInfoResponse, EndServiceResponse, PauseServiceResponse } from '../types/accountSettings';

export const useScheduleChnageRequestMutation = () => {
  return createApiMutation<CoachingScheduleResponse, CoachingScheduleRequest>({
    mutationFn: async (request, signal) => {
      const response = await postScheduleChangeRequest(request.memberId as string, request, signal);
      const responseData = getDataFromResponse(response);

      if (responseData.statusCode && responseData.statusCode !== 200) {
        throw createApiError(responseData.message || 'Schedule change request failed', responseData);
      }

      return responseData;
    },
    errorSource: ErrorSource.SCHEDULE_CHANGE_REQUEST,
    loadingActions: {
      start: (dispatch) => {},
      end: (dispatch) => {}
    },
    onSuccessHandler: (responseData, variables, context, dispatch) => {},
    module: 'AccountSettings',
  });
};

export const usePauseServiceMutation = () => {
  return createApiMutation<PauseServiceResponse, string>({
    mutationFn: async (memberId, signal) => {
      const response = await postPauseService(memberId, signal);
      const responseData = getDataFromResponse(response);

      if (responseData.statusCode && responseData.statusCode !== 200) {
        throw createApiError(responseData.message || 'Pause service failed', responseData);
      }

      return responseData;
    },
    errorSource: ErrorSource.PAUSE_SERVICE,
    loadingActions: {
      start: (dispatch) => {},
      end: (dispatch) => {}
    },
    onSuccessHandler: (responseData, variables, context, dispatch) => {},
    module: 'AccountSettings',
  });
};

export const useEndServiceMutation = () => {
  return createApiMutation<EndServiceResponse, string>({
    mutationFn: async (memberId, signal) => {
      const response = await postEndService(memberId, signal);
      const responseData = getDataFromResponse(response);

      if (responseData.statusCode && responseData.statusCode !== 200) {
        throw createApiError(responseData.message || 'End service failed', responseData);
      }

      return responseData;
    },
    errorSource: ErrorSource.END_SERVICE,
    loadingActions: {
      start: (dispatch) => {},
      end: (dispatch) => {}
    },
    onSuccessHandler: (responseData, variables, context, dispatch) => {},
    module: 'AccountSettings',
  });
};

export const useUpdatePersonalInfoMutation = () => {
  return createApiMutation<EditPersonalInfoResponse, EditPersonalInfoRequest>({
    mutationFn: async (request, signal) => {
      const response = await postUpdatePersonalInfo(request.memberId as string, request, signal);
      const responseData = getDataFromResponse(response);

      if (responseData.statusCode && responseData.statusCode !== 200) {
        throw createApiError(responseData.message || 'Personal info update request failed', responseData);
      }

      return responseData;
    },
    errorSource: ErrorSource.UPDATE_PERSONAL_INFO,
    loadingActions: {
      start: (dispatch) => {},
      end: (dispatch) => {}
    },
    onSuccessHandler: (responseData, variables, context, dispatch) => {},
    module: 'AccountSettings',
  });
};
